import { IInventoryPage } from '../../../inventory-page.interface';


export const UPLOAD_KDP_EDIT_PAGE: IInventoryPage = {
	'route': '/upload/kdp/edit',
	'title': 'Edit Kdp',
	'uiReference': [
		'Add designs Import Listings & Images',
		'Listing editor',
		'Previous design',
		'Design Tag',
		'Next design',
		'Scripted Replace',
		'Design tags /3',
		'Listing status',
		'Tagging actions',
		'Restore Default Options',
		'Advanced Options',
		'Load',
		'Clear',
		'Read More',
		'Clear Filters',
		'Back to Designs',
		'Back to Edit',
		'Back to Profiles',
		'Save',
		'Back To Designs',
		'Back To Edit',
		'kdp-view works!',
		'notes-view works!',
		'Quick Search',
		'Search designs',
		'Text Replace',
		'Current text',
		'New text',
		'Replace',
		'This option will give you ability to replace all the matched text the by keeping with existing format of the text',
		'This option will give you ability to replace all matched text that start with given text',
		'This option will give you ability to replace all matched text that end with given text',
		'This option will give you ability to replace all matched text that matched with given text.',
		'This option will give you ability to replace all matched text that exactly matched with given text.',
		'Placeholder / old',
		'from',
		'Replace All',
		'Replace Selected',
		'ID:'
	],
	'sources': [
		'apps/flying-projects/frontend/webapp/src/app/pages/upload/kdp/edit-kdp/edit-kdp-routing.module.ts',
		'apps/flying-projects/frontend/webapp/src/app/pages/upload/kdp/edit-kdp/edit-kdp.component.ts',
		'apps/flying-projects/frontend/webapp/src/app/pages/upload/kdp/edit-kdp/edit-kdp.component.html',
		'apps/flying-projects/frontend/webapp/src/app/pages/upload/pod/shared/data-import/data-import.component.ts',
		'apps/flying-projects/frontend/webapp/src/app/pages/upload/pod/shared/data-import/data-import.component.html',
		'apps/flying-projects/frontend/webapp/src/app/pages/upload/shared-components/edit-page/edit-components/navigation-bar/navigation-bar.component.ts',
		'apps/flying-projects/frontend/webapp/src/app/pages/upload/shared-components/edit-page/edit-components/navigation-bar/navigation-bar.data.ts',
		'apps/flying-projects/frontend/webapp/src/app/pages/upload/shared-components/edit-page/edit-components/navigation-bar/navigation-bar.component.html',
		'apps/flying-projects/frontend/webapp/src/app/pages/upload/shared-components/edit-page/edit-components/design-list/design-list.component.ts',
		'apps/flying-projects/frontend/webapp/src/app/pages/upload/shared-components/edit-page/edit-components/design-list/design-list.data.ts',
		'apps/flying-projects/frontend/webapp/src/app/pages/upload/shared-components/edit-page/edit-components/design-list/design-list.component.html',
		'apps/flying-projects/frontend/webapp/src/app/pages/upload/kdp/edit-kdp/edit-views/kdp-view/kdp-view.component.ts',
		'apps/flying-projects/frontend/webapp/src/app/pages/upload/kdp/edit-kdp/edit-views/kdp-view/kdp-view.component.html',
		'apps/flying-projects/frontend/webapp/src/app/pages/upload/kdp/edit-kdp/edit-views/notes-view/notes-view.component.ts',
		'apps/flying-projects/frontend/webapp/src/app/pages/upload/kdp/edit-kdp/edit-views/notes-view/notes-view.component.html',
		'apps/flying-projects/frontend/webapp/src/app/pages/upload/shared-components/edit-page/edit-components/navigation-bar/sub-components/design-filter/design-filter.component.ts',
		'apps/flying-projects/frontend/webapp/src/app/pages/upload/shared-components/edit-page/edit-components/navigation-bar/sub-components/design-filter/design-filter.data.ts',
		'apps/flying-projects/frontend/webapp/src/app/pages/upload/shared-components/edit-page/edit-components/navigation-bar/sub-components/design-filter/design-filter.component.html',
		'apps/flying-projects/frontend/webapp/src/app/pages/upload/shared-components/edit-page/edit-components/navigation-bar/sub-components/text-replace/text-replace.component.ts',
		'apps/flying-projects/frontend/webapp/src/app/pages/upload/shared-components/edit-page/edit-components/navigation-bar/sub-components/text-replace/text-replace.data.ts',
		'apps/flying-projects/frontend/webapp/src/app/pages/upload/shared-components/edit-page/edit-components/navigation-bar/sub-components/text-replace/text-replace.component.html',
		'apps/flying-projects/frontend/webapp/src/app/pages/upload/shared-components/edit-page/edit-components/navigation-bar/sub-components/scripted-replace/scripted-replace.component.ts',
		'apps/flying-projects/frontend/webapp/src/app/pages/upload/shared-components/edit-page/edit-components/navigation-bar/sub-components/scripted-replace/scripted-replace.component.html',
		'apps/flying-projects/frontend/webapp/src/app/pages/upload/shared-components/edit-page/edit-components/design-cards/design-card-element/design-card-element.component.ts',
		'apps/flying-projects/frontend/webapp/src/app/pages/upload/shared-components/edit-page/edit-components/design-cards/design-card-element/design-card-element.component.html',
		'apps/flying-projects/frontend/webapp/src/app/pages/upload/shared-components/edit-page/edit-components/navigation-bar/sub-components/scripted-replace/scripted-replace-suggestions/scripted-replace-suggestions.component.ts',
		'apps/flying-projects/frontend/webapp/src/app/pages/upload/shared-components/edit-page/edit-components/navigation-bar/sub-components/scripted-replace/scripted-replace-suggestions/scripted-replace-suggestions.component.html'
	]
};
